module.exports = __webpack_public_path__ + "media/images/user-plus-8a6ffbee10309b928e87aa8e94d6d4a0.svg";